import { Container, Heading3, Icon, Paragraph } from "shared/components";

import styles from "./Content053.module.scss";

export const Hero053 = ({ payload }) => {
  const title = payload?.title ?? "";
  const address = payload?.address ?? "";
  const email = payload?.email ?? "";
  const phone = payload?.phone ?? "";
  const addressTitle = payload?.addressTitle ?? "";
  const emailTitle = payload?.emailTitle ?? "";
  const phoneTitle = payload?.phoneTitle ?? "";

  const contacts = [
    {
      id: "address",
      label: addressTitle,
      text: address,
      value: null,
      type: "text",
    },
    {
      id: "tel",
      label: phoneTitle,
      text: phone,
      value: `tel:${phone}`,
      type: "link",
    },
    {
      id: "email",
      label: emailTitle,
      text: email,
      value: `mailto:${email}`,
      type: "link",
    },
  ];

  return (
    <div className={styles.wrapper}>
      <Container>
        <Heading3 className={styles.title} color="dark">
          {title}
        </Heading3>
        <div className={styles.items}>
          {contacts.map((item) => (
            <div className={styles.item} key={item.id}>
              <div className={styles["icon-wrapper"]}>
                <Icon name={item.id} className={styles.icon} />
              </div>

              <div className={styles.block}>
                <Paragraph color="grey" className={styles.label}>
                  {item.label}
                </Paragraph>
                {item.type === "text" ? (
                  <Paragraph
                    className={styles.text}
                    appearance="bold"
                    color="dark"
                  >
                    {item.text}
                  </Paragraph>
                ) : (
                  <a href={item.value} type={item.type} className={styles.link}>
                    {item.text}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Hero053;
